<app-header></app-header>
<app-set-meta title="新規会員登録｜Forbes CAREER"></app-set-meta>
<div class="wrapper">
  <div class="pc_contents_wrapper">
    <ng-container *ngIf="!finished">
      <ng-container *ngIf="false; else maintenance">
        <h1>新規会員登録</h1>

        <p *ngIf="!fromEntry && !fromVote; then normal; else fromAuthGuard"></p>
        <ng-template #normal><p>登録は無料。いますぐはじめましょう。</p></ng-template>
        <ng-template #fromAuthGuard>
          <p *ngIf="fromEntry">エントリーには無料会員登録が必要です。</p>
          <p *ngIf="fromVote">投票には会員登録またはログインが必要です</p>
        </ng-template>

        <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

        <div class="form_wrapper">
          <button class="btn btn-facebook btn-block" (click)="signupWithFacebook()">Facebookで続行</button>
          <button class="btn btn-google btn-block" (click)="signupWithGoogle()">Googleアカウントで続行</button>

          <div class="or"><span>または</span></div>

          <form [formGroup]="form">
            <div class="form-group">
              <input placeholder="メールアドレス" formControlName="email" class="form-control" />
              <div *ngIf="email.invalid && email.touched" class="alert alert-danger">
                <div *ngIf="email.errors.required">メールアドレスを入力してください</div>
                <div *ngIf="email.errors.email">メールアドレスの形式が異なっています</div>
              </div>
            </div>
            <div class="form-group">
              <input placeholder="パスワード" type="password" formControlName="password" class="form-control" />
              <div *ngIf="password.invalid && password.touched" class="alert alert-danger">
                <div *ngIf="password.errors.required">パスワードを入力してください</div>
                <div *ngIf="password.errors.minlength">パスワードは8文字以上入力してください</div>
              </div>
            </div>
            <button (click)="doSignup()" class="btn btn-primary btn-block">続行</button>
          </form>

          <p>
            登録することで、
            <a href="https://linkties.com/privacy/" target="_blank">個人情報保護方針</a>
            および
            <a href="/agreement" target="_blank">会員規約</a>
            に同意したものとみなされます。
          </p>

          <p class="to_login">
            アカウントをお持ちの方は
            <a [routerLink]="['/login']" [queryParams]="{ url: backUrl }">こちら</a>
          </p>
        </div>
      </ng-container>

      <ng-template #maintenance>
        <div class="maintenance">
          <p class="maintenance__text">
            サイトの移行作業に伴い、以下の期間中はログインいただけません。
            <br />
            <br />
            <span class="maintenance__text__date">12/5（月）10:00 - 12/9（金）終日</span>
            <br />
            <br />
            ご不便をおかけしますが、ご理解のほど宜しくお願い申し上げます。
            <br />
            <br />
            お問合せ：career_cs@linkties.com
          </p>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <app-footer></app-footer>
</div>
<!-- /.wrapper -->
